module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-192x192-951a85d563e7ed3975b25fdeb414474b.png";